export default __webpack_public_path__ + "static/media/black-dancing3-background@2x.79ff9321.jpg";